import { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { Booking } from "../../../../types/bookings";

export const useBookingSelector = () => {
  const bookingDetails = useSelector<RootState, Booking>((state) => state?.newBooking?.bookingDetails);

  return useMemo(() => {
    const { paymentPlanApproval } = bookingDetails ?? {};
    const isPaymentPlanApprovalSent = paymentPlanApproval === "sent";

    return {
      ...bookingDetails,
      isPaymentPlanApprovalSent,
    };
  }, [bookingDetails]);
};
